import InlineSvg from "../lib/InlineSvg.tsx";
import TextSlideView from "../lib/TextSlideView.tsx";
import type { TextSlideData } from "../lib/text-slide.ts";
import type { Content } from "../lib/types.ts";

/** Renders a content item visually for cards, pickers, and the editor preview. */
export default function ContentPreview({ content }: { content: Content }) {
  if (content.type === "image" && content.url) {
    // A generated description beats the name, which for an imported deck is
    // "weekly announcements — slide 4" for every page.
    const alt =
      (content.data as { alt?: string } | null)?.alt?.trim() || content.name;
    return <img className="cp cp-media" src={content.url} alt={alt} />;
  }
  if (content.type === "video" && content.url) {
    return <video className="cp cp-media" src={content.url} muted loop playsInline />;
  }
  if (content.type === "svg") {
    const svg = (content.data as { svg?: string } | null)?.svg ?? "";
    // Scoped ids — a grid of cards is a dozen SVGs in one document, and the
    // composer names its gradients `#bg` in nearly all of them.
    return <InlineSvg className="cp cp-svg" svg={svg} />;
  }
  if (content.type === "text") {
    return (
      <TextSlideView
        slide={(content.data ?? {}) as TextSlideData}
        fit="box"
        className="cp"
      />
    );
  }
  return <div className="cp cp-empty">No preview</div>;
}
